// src/pages/PrivacyPolicy/PrivacyPolicy.tsx
import React from 'react';
import HeadCommon from '../../components/HeadCommon';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
    <HeadCommon />
    <main
      className="PrivacyPolicy-page other-page"
    >
      <h1>プライバシーポリシー</h1>
      <section className="privacy-policy">
        <h2>1. はじめに</h2>
        <p>
          autoChat AI（以下「当社」）は、ユーザーのプライバシーを尊重し、個人情報の保護に努めています。本プライバシーポリシーは、当社のWebアプリ「auto-chat.ai」（以下「本サービス」）における個人情報の収集、利用、保管、開示に関する方針を説明するものです。
        </p>

        <h2>2. 収集する情報</h2>
        <p>当社は、本サービスを提供するために以下の情報を収集します。</p>
        <ul>
          <li>
            <strong>個人情報:</strong>{' '}
            ユーザーがアカウントを作成する際に提供する名前、メールアドレス、およびGoogle認証情報。
          </li>
          <li>
            <strong>使用情報:</strong>{' '}
            ツールの使用回数、使用APIキー、利用プラン情報、利用したポイント数などの使用履歴。
          </li>
          <li>
            <strong>技術情報:</strong>{' '}
            アクセスログ、デバイス情報、IPアドレス、ブラウザ情報。
          </li>
        </ul>

        <h2>3. 情報の利用</h2>
        <p>当社は、収集した情報を以下の目的で利用します。</p>
        <ul>
          <li>本サービスの提供および改善</li>
          <li>ユーザー認証およびセキュリティの確保</li>
          <li>ポイントの管理および課金処理</li>
          <li>ユーザーサポートおよびお問い合わせ対応</li>
          <li>
            マーケティングおよびプロモーション活動（ユーザーの同意がある場合）
          </li>
        </ul>

        <h2>4. 情報の共有</h2>
        <p>
          当社は、ユーザーの同意がない限り、個人情報を第三者と共有しません。ただし、法令に基づく要請があった場合や、本サービスの運営に必要な範囲で信頼できるパートナーと情報を共有する場合があります。
        </p>

        <h2>5. 情報の保管</h2>
        <p>
          当社は、収集した情報を適切な技術的および組織的な措置を講じて保護します。個人情報は、利用目的に必要な期間のみ保管されます。
        </p>

        <h2>6. ユーザーの権利</h2>
        <p>
          ユーザーは、自身の個人情報にアクセスし、修正、削除、または利用の停止を求める権利があります。これらの要求は、当社のサポートチームに連絡することで行えます。
        </p>

        <h2>7. プライバシーポリシーの変更</h2>
        <p>
          当社は、本プライバシーポリシーを随時更新することがあります。重要な変更がある場合は、ユーザーに通知します。
        </p>

        <h2>8. お問い合わせ</h2>
        <p>
          メールアドレス:{' '}
          <a href="mailto:support@auto-chat.ai">support@auto-chat.ai</a>
        </p>
      </section>
    </main>
    </>
  );
};

export default PrivacyPolicy;
